<template>
  <div class="product_zx">
    <!-- 产品中心 -->
    <!-- nav -->
    <index-nav></index-nav>
    <!-- bottom -->
    <index-bottom></index-bottom>
    <div class="content">
      <!-- banner -->
      <div class="banner">
        <img src="/statics/images/info/cp_banner.png" alt />
      </div>

      <!-- 总导航 -->
      <div class="allnav inner">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
          <el-tab-pane
            v-for="(item,index) in cateList"
            :key="index"
            :label="item.text"
            :name="index.toString()"
          ></el-tab-pane>
          <!-- <el-tab-pane label="电厂系列产品" name="second"></el-tab-pane> -->
        </el-tabs>
      </div>
      <!-- 子导航 -->
      <div class="chanpincon">
        <div class="inner">
          <div class="childnav">
            <div class="desc">
              <img src="/statics/images/info/icon.png" alt />
              <span>产品列表</span>
            </div>
            <el-tabs
              :tab-position="tabPosition"
              v-model="activeChildname"
              @tab-click="childHandleClick"
              v-if="cateList.length!=0"
            >
              <!-- :label="item.text" -->
              <el-tab-pane
                v-for="(item,index) in cateList[cateChild].children"
                :key="index"
                :name="item.value.toString()"
              >
                <a href="javascript:scroll(0,0)" slot="label" :class="item.value==28?'rfsb' :''">{{item.text}}</a>
              </el-tab-pane>
            </el-tabs>
          </div>
          <div class="cp_right">
            <!-- 产品列表 -->
            <div class="cp_list">
              <div
                class="cp_item"
                v-for="(item,index) in goodsList"
                :key="index"
                @click="toCp_info(item.id)"
              >
                <div class="pic">
                  <img :src="adddom(item.thumb)" alt />
                </div>
                <div class="title">
                  <span>{{item.name}}</span>
                </div>
                <div class="more">
                  <span>查看详情</span>
                  <i class="el-icon-arrow-right"></i>
                </div>
              </div>
            </div>
            <!-- 分页 -->
            <div class="fenye clearfix" v-if="goodsList.length!=0">
              <el-pagination
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-size="pages.size"
                layout="prev, pager, next, jumper"
                :total="goodsTotal"
                prev-text="上一页"
                next-text="下一页"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- bottom -->
    <!-- <index-bottom></index-bottom> -->
    <!-- footer -->
    <index-footer></index-footer>
  </div>
</template>

<script>
import indexNav from "./../components/nav";
import indexBottom from "./../components/bottom";
import indexFooter from "./../components/footer";
export default {
  data() {
    return {
      cateList: [], //产品分类
      activeName: "0", //总导航
      activeChildname: "", //子导航
      tabPosition: "left", //子导航对齐方式
      currentPage: 1, //当前页数
      cateChild: 0,
      goodsList: [], //产品列表
      goodsTotal: 0, //总条数
      cateId: "",
      pages: {
        page: 1,
        size: 9
      },
      fromName: ""
    };
  },
  components: {
    indexNav,
    indexBottom,
    indexFooter
  },
  created() {
    // console.log(this.$route)
    // 产品分类
    // console.log("created==========");
    if (
      (this.$route.query && this.$route.query.num == 0) ||
      this.$route.query.num == 1
    ) {
      // console.log(this.$route.query.num);
      this.activeName = this.$route.query.num.toString();
      this.cateChild = this.$route.query.num;
    }
    this.getCate();
  },
  methods: {
    // 图片拼接地址
    adddom(src) {
      if (src == "" || src == undefined || src == null) {
        console.log("src地址有问题");
        return "";
      }
      if (src.substr(0, 4).toLowerCase() === "http") {
        return src;
      }
      return this.$url + src;
    },
    getCate() {
      var that = this;
      that.$api.index.goodsCate({}).then(function(res) {
        if (res.code == 200) {
          that.cateList = res.result;
          if (that.cateList && that.cateList[that.cateChild].children) {
            that.activeChildname = that.cateList[
              that.cateChild
            ].children[0].value.toString();
            that.cateId = that.activeChildname;
            that.pages.page = 1;
            that.getList();
          } else {
            that.goodsList = [];
          }
        }
      });
    },
    //产品列表
    getList() {
      var that = this;
      var ps = {
        cate_id: that.cateId,
        page: that.pages.page,
        size: that.pages.size
      };
      that.$api.index.goodsList(ps).then(function(res) {
        if (res.code == 200) {
          that.goodsList = res.result.list;
          that.goodsTotal = res.result.total;
        }
      });
    },
    // 总导航选中触发
    handleClick(tab, event) {
      // console.log(tab.name);
      var that = this;
      that.activeName = tab.name;
      that.cateChild = tab.name;
      if (that.cateList && that.cateList[that.cateChild].children) {
        that.activeChildname = that.cateList[
          that.cateChild
        ].children[0].value.toString();
        that.cateId = that.activeChildname;
        that.pages.page = 1;
        that.getList();
      } else {
        that.goodsList = [];
      }
    },
    // 子导航选中触发
    childHandleClick(tab, event) {
      // console.log(tab.name);
      this.cateId = tab.name;
      this.pages.page = 1;
      this.goodsList = [];
      this.getList();
    },
    // 页数改变时触发
    handleCurrentChange(val) {
      // console.log(val);
      this.pages.page = val;
      this.getList();
    },
    // 跳转到产品中心详情
    toCp_info(id) {
      this.$router.push({
        path: "/product_zxinfo",
        query: {
          cate: this.cateChild,
          id: id
        }
      });
    },
    pageScroll() {
      //把内容滚动指定的像素数（第一个参数是向右滚动的像素数，第二个参数是向下滚动的像素数）
      window.scrollBy(0, -100);
      //延时递归调用，模拟滚动向上效果
      scrolldelay = setTimeout("pageScroll()", 100);
      //获取scrollTop值，声明了DTD的标准网页取document.documentElement.scrollTop，否则取document.body.scrollTop；因为二者只有一个会生效，另一个就恒为0，所以取和值可以得到网页的真正的scrollTop值
      var sTop = document.documentElement.scrollTop + document.body.scrollTop;
      //判断当页面到达顶部，取消延时代码（否则页面滚动到顶部会无法再向下正常浏览页面）
      if (sTop == 0) clearTimeout(scrolldelay);
    }
  },
  mounted: function() {},
  watch: {
    $route(to, from) {
      // console.log("to", to);
      // console.log("from", from);
      this.fromName = from.name;
    }
  },
  activated: function() {
    // console.log(this.fromName);
    if (this.fromName != "product-zxinfo") {
      if (
        (this.$route.query && this.$route.query.num == 0) ||
        this.$route.query.num == 1
      ) {
        // console.log(this.$route.query.num);
        this.activeName = this.$route.query.num.toString();
        this.cateChild = this.$route.query.num;
      } else {
        this.activeName = "0";
        this.cateChild = 0;
      }
      this.getCate();
    }
  }
};
</script>

<style>
</style>